// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9562af2a","455":"51166383","977":"49b67999"}[chunkId] + ".chunk.js";
};